module.exports = __webpack_public_path__ + "76f9873fc536031e4d0508d3ece7ac0f.svg";